import React, {Component, createElement, PropTypes} from "react";
import {Modal} from "react-bootstrap";

import {LoadingIcon} from "@ergeon/erg-components-react";

import {trackEvent} from "metrics";
import api from "v2/api";
import {Route} from "v2/api/Records";

const CLEAR_DELAY = 5000;

export default class SendEmailLink extends Component {
  static contextTypes = {
    params: PropTypes.shape({
      routeId: PropTypes.string.isRequired,
    }),
    routeData: PropTypes.instanceOf(Route),
  }
  static defaultProps = {
    component: "div",
  }
  static propTypes = {
    component: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string,
    ]),
  }

  state = {
    clicked: false,
    error: null,
    sent: null,
  }

  handleClearState = (evt) => {
    evt && evt.preventDefault();
    this.setState({
      error: null,
      sent: null,
    });
  }

  handleSendEmail = (evt) => {
    evt.preventDefault();
    this.setState({
      clicked: true,
    });

    const {params: {date, routeId}, routeData} = this.context;
    const clearState = () => {
      setTimeout(this.handleClearState, CLEAR_DELAY);
    };

    api()
      .post(this.apiUrl, {}, {
        validateStatus: (status) => status === 204,
      })
      .then(() => {
        trackEvent("Send Email", ["Route", "send-email", routeId], {
          Date: date,
          ID: routeId,
          Type: routeData.type,
        });
        this.setState({
          clicked: false,
          error: false,
          sent: true,
        }, clearState);
      })
      .catch(() => {
        this.setState({
          clicked: false,
          error: true,
          sent: false,
        }, clearState);
      });
  }

  get apiUrl() {
    const {params: {routeId}} = this.context;
    return `/routes/${routeId}/send-email`;
  }

  renderModal() {
    const {clicked, error, sent} = this.state;
    if (!clicked && !error && !sent) {
      return null;
    }

    let content;
    if (clicked) {
      content = (
        <p className="text-muted">
          <LoadingIcon />
        </p>
      );
    } else if (sent) {
      content = <p>Email Sent Successfully.</p>;
    } else if (error) {
      content = (
        <p className="text-danger">
          Server error while sending email. Please try again later.
        </p>
      );
    }

    return (
      <Modal key="modal" show>
        <Modal.Body>
          {content}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-success"
            disabled={clicked}
            onClick={this.handleClearState}
            type="button">
            OK
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const {component} = this.props;
    return createElement(component, {}, [
      <a href="#" key="link" onClick={this.handleSendEmail}>Email</a>,
      this.renderModal(),
    ]);
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/SendEmailLink.js
 **/